import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StorageService } from 'src/app/shared/storage/storage.service';

const KEY_DRIVER = 'driver';

// Work status display name mappings
const WORK_STATUS_DISPLAY_MAP: { [key: string]: string } = {
  // Canada - camelCase format
  'canWorkPermit': 'Work Permit',
  'canResident': 'Resident',
  'canCitizen': 'Citizen',
  // USA - camelCase format
  'usWorkVisa': 'Work Visa',
  'usResident': 'Resident',
  'usCitizen': 'Citizen',
  // Canada - PascalCase format (legacy)
  'CanWorkPermit': 'Work Permit',
  'CanResident': 'Resident',
  'CanCitizen': 'Citizen',
  // USA - PascalCase format (legacy)
  'UsWorkVisa': 'Work Visa',
  'UsResident': 'Resident',
  'UsCitizen': 'Citizen'
};

@Component({
    selector: 'app-dqf-driver-contact-information',
    templateUrl: './dqf-driver-contact-information.component.html',
    styleUrls: ['./dqf-driver-contact-information.component.scss'],
    standalone: true,
    imports: [CommonModule]
})
export class DqfDriverContactInformationComponent implements OnInit {
  @Input() driverVersionDetails: any;
  data = [];
  isLoading = true;
  constructor(private storageService: StorageService) { }

  ngOnInit(): void {
    this.getDriver();
  }

  private getWorkStatusDisplayName(workStatus: string): string {
    if (!workStatus) return '';
    return WORK_STATUS_DISPLAY_MAP[workStatus] || workStatus;
  }

  private getDriver(): void {
    // Simulate API loading delay
    setTimeout(() => {
      const driver = this.driverVersionDetails ?? this.storageService.find(KEY_DRIVER);
      if (driver) {
        this.data = [
          { propertyName: 'Address', propertyValue: `${driver.address || ''}` },
          { propertyName: 'Phone', propertyValue: `${driver.phoneNumber || ''}` },
          { propertyName: 'Email', propertyValue: `${driver.email || ''}` },
          { propertyName: 'Work Status', propertyValue: this.getWorkStatusDisplayName(driver.workStatus) }
        ];
      }
      this.isLoading = false;
    }, 100);
  }

}
